import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.array.sort.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.filter.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
/**
 * 参数：prefixCls，默认bee-table,用于设置图标的样式
 * @param {*} Table
 * @param {*} Icon
 */

export default function sort(Table, Icon) {
  var _class, _temp;

  var IconType = [{
    'type': 'flat',
    'icon': 'uf-symlist',
    'order': 'flatscend'
  }, {
    'type': 'up',
    'icon': 'uf-sortup',
    'order': 'ascend'
  }, {
    'type': 'down',
    'icon': 'uf-sortdown',
    'order': 'descend'
  }];
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(SortTable, _Component);

    var _super = _createSuper(SortTable);

    function SortTable(props) {
      var _this2;

      _classCallCheck(this, SortTable);

      _this2 = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this2), "_initSort", function () {
        var sort = _this2.props.sort;
        var flatColumns = _this2.state.flatColumns;
        var needSort = false;
        flatColumns.forEach(function (item) {
          if (item.order == 'descend' || item.order == 'ascend') {
            needSort = true;
            return;
          }
        });

        if (needSort) {
          if (sort && sort.mode !== "single") {
            //多列排序情况下数据排序
            var data = _this2.multiSort(flatColumns);

            _this2.setState({
              data: data
            });
          } else {//单列排序情况下如果data受控会出现死循环，需要重新考虑
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this2), "getOrderNum", function () {
        var orderNum = 0; //todo 1

        _this2.state.flatColumns.forEach(function (item, index) {
          if (item.order == "ascend" || item.order == "descend") {
            orderNum++;
          }
        });

        return orderNum ? orderNum : 1;
      });

      _defineProperty(_assertThisInitialized(_this2), "changeOrderNum", function (column) {
        var flatColumns = _this2.state.flatColumns; //todo 2

        flatColumns.forEach(function (col) {
          if (col.orderNum > column.orderNum) {
            col.orderNum--;
          }

          if (column.key == col.key) {
            col.orderNum = "";
          }
        });

        _this2.setState({
          flatColumns: flatColumns
        });
      });

      _defineProperty(_assertThisInitialized(_this2), "getOrderCols", function (columns) {
        var orderCols = []; //todo 3

        columns.forEach(function (item) {
          if (item.order == "ascend" || item.order == "descend") {
            orderCols.push({
              order: item.order,
              field: item.dataIndex,
              orderNum: item.orderNum
            });
          }
        });
        return orderCols;
      });

      _defineProperty(_assertThisInitialized(_this2), "_sortBy", function (pre, after, orderCols, orderColslen, currentIndex) {
        var currentCol = orderCols[currentIndex];
        var getMultiSorterValueFunc = currentCol.getMultiSorterValue;
        var preKey = pre[currentCol.key];
        var afterKey = after[currentCol.key];

        if (getMultiSorterValueFunc) {
          preKey = getMultiSorterValueFunc(pre, currentCol);
          afterKey = getMultiSorterValueFunc(after, currentCol);
        }

        var colSortFun = currentCol.sorter;

        if (typeof colSortFun !== 'function') {
          colSortFun = function colSortFun() {
            return preKey - afterKey;
          };
        }

        if (preKey == afterKey && currentIndex + 1 <= orderColslen) {
          return _this2._sortBy(pre, after, orderCols, orderColslen, currentIndex + 1);
        }

        if (currentCol.order == "ascend") {
          return colSortFun(pre, after);
        } else {
          return -colSortFun(pre, after);
        }
      });

      _defineProperty(_assertThisInitialized(_this2), "multiSort", function (columns) {
        var _this2$state = _this2.state,
            data = _this2$state.data,
            _this2$state$oldData = _this2$state.oldData,
            oldData = _this2$state$oldData === void 0 ? [] : _this2$state$oldData;

        var self = _assertThisInitialized(_this2);

        var orderCols = {},
            orderColslen = 0; //todo 4

        columns.forEach(function (item) {
          if (item.orderNum) {
            orderColslen++;
            orderCols[item.orderNum] = item;
          }
        });

        if (orderColslen > 0) {
          data = data.sort(function (a, b) {
            return self._sortBy(a, b, orderCols, orderColslen, 1);
          });
        } else {
          data = oldData.concat();
        }

        return data;
      });

      _defineProperty(_assertThisInitialized(_this2), "toggleSortOrder", function (order, column) {
        var _this2$state2 = _this2.state,
            data = _this2$state2.data,
            _this2$state2$oldData = _this2$state2.oldData,
            oldData = _this2$state2$oldData === void 0 ? [] : _this2$state2$oldData,
            flatColumns = _this2$state2.flatColumns;
        var sort = _this2.props.sort;
        var seleObj;

        if (!oldData.length) {
          oldData = data.concat();
        }

        var sortCol; //单列排序，清空其他列的排序

        if (sort.mode == "single") {
          //todo 5
          flatColumns.forEach(function (da) {
            if (da.key == column.key) {
              seleObj = da;
            } else {
              if (da.order) {
                da.order = "flatscend"; //还原排序状态
              }
            }
          });
          seleObj.order = order; //当前排序列状态

          sortCol = [{
            order: order,
            field: seleObj.dataIndex
          }]; //通过后端请求

          if (sort.backSource && typeof sort.sortFun === "function") {
            //获取排序的字段和方式
            sort.sortFun(sortCol);
          } else {
            if (order === "ascend") {
              data = data.sort(function (a, b) {
                return typeof column.sorter == 'function' && column.sorter(a, b);
              });
            } else if (order === "descend") {
              data = data.sort(function (a, b) {
                return typeof column.sorter == 'function' && column.sorter(b, a);
              });
            } else {
              data = oldData.concat();
            }

            typeof sort.sortFun === "function" && sort.sortFun(sortCol, data, oldData);
          }
        } else {
          //多列排序
          seleObj = flatColumns.find(function (da) {
            return da.key == column.key;
          });
          seleObj.order = order;

          if (order === "flatscend") {
            _this2.changeOrderNum(column);
          }

          if (!seleObj.orderNum && (order == "ascend" || order == "descend")) {
            seleObj.orderNum = _this2.getOrderNum();
          }

          sortCol = _this2.getOrderCols(flatColumns);

          if (sort.backSource && typeof sort.sortFun === "function") {
            sort.sortFun(sortCol);
          } else {
            data = _this2.multiSort(flatColumns);
            typeof sort.sortFun === "function" && sort.sortFun(sortCol, data, oldData);
          }
        }

        _this2.setState({
          data: data,
          oldData: oldData,
          flatColumns: flatColumns
        });
      });

      _defineProperty(_assertThisInitialized(_this2), "renderColumnsDropdown", function (columns) {
        var tempColumns = [],
            rsColumns = [];
        tempColumns = columns.map(function (originColumn) {
          var column = Object.assign({}, originColumn);
          return _this2.sortColumn(column);
        });
        rsColumns = _this2._flatToColumn(tempColumns);
        return rsColumns;
      });

      _defineProperty(_assertThisInitialized(_this2), "sortColumn", function (column) {
        var mode = _this2.props.sort.mode;
        var prefixCls = _this2.props.prefixCls;
        var iconTypeIndex = 0;
        var sorterClass = "flat";

        if (column.order === "ascend") {
          iconTypeIndex = 1;
          sorterClass = "up";
        } else if (column.order === "descend") {
          iconTypeIndex = 2;
          sorterClass = "down";
        }

        var sortButton; // sorter和sortEnable均可触发排序,且sorter优先级更高

        if (column.sorter || column.sortEnable) {
          //大于0说明不是升序就是降序，判断orderNum有没有值，没有值赋值
          if (column.sortEnable && !column.sorter) {
            switch (column.fieldType) {
              case 'number':
                {
                  column.sorter = _this2.numberSortFn(column.dataIndex);
                  break;
                }

              case 'stringChinese':
                {
                  column.sorter = _this2.chineseSortFn(column.dataIndex);
                  break;
                }

              default:
                {
                  column.sorter = _this2.defaultSortFn(column.dataIndex);
                  break;
                }
            }
          }

          if (iconTypeIndex > 0 && !column.orderNum && mode == "multiple") {
            column.orderNum = _this2.getOrderNum();
          }

          sortButton = /*#__PURE__*/React.createElement("div", {
            className: "".concat(prefixCls, "-column-sorter")
          }, /*#__PURE__*/React.createElement("span", {
            className: "".concat(prefixCls, "-column-sorter-").concat(sorterClass),
            onClick: function onClick() {
              _this2.toggleSortOrder(IconType[iconTypeIndex == 2 ? 0 : iconTypeIndex + 1].order, column);

              if (column.sorterClick) {
                column.sorterClick(column, IconType[iconTypeIndex].type);
              }
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "uf ".concat(IconType[iconTypeIndex].icon)
          }), /*#__PURE__*/React.createElement("span", null, column.orderNum)));
        }

        column.title = /*#__PURE__*/React.createElement("span", null, column.title, sortButton);
        return column;
      });

      _defineProperty(_assertThisInitialized(_this2), "defaultSortFn", function (key) {
        return function (a, b) {
          return a[key] >= b[key] ? 1 : -1;
        };
      });

      _defineProperty(_assertThisInitialized(_this2), "numberSortFn", function (key) {
        return function (a, b) {
          var numberA = parseFloat(a[key]);
          var numberB = parseFloat(b[key]);
          return numberA >= numberB ? 1 : -1;
        };
      });

      _defineProperty(_assertThisInitialized(_this2), "chineseSortFn", function (key) {
        return function (a, b) {
          return a[key].localeCompare(b[key], 'zh-Hans-CN', {
            sensitivity: 'accent'
          });
        };
      });

      _defineProperty(_assertThisInitialized(_this2), "handleDropBorder", function (event, newWidth, newColumn, newColumns) {
        var onDropBorder = _this2.props.onDropBorder;

        var flatColumn = _this2.state.flatColumns.find(function (column) {
          return column.dataIndex == newColumn.dataIndex;
        });

        flatColumn.width = newWidth;

        _this2.setState({
          flatColumns: _this2.state.flatColumns
        });

        typeof onDropBorder == 'function' && onDropBorder(event, newWidth, newColumn, newColumns);
      });

      var _flatColumns = _this2._toFlatColumn(props.columns, -1);

      _this2.state = {
        data: _this2.props.data,
        columns: props.columns,
        flatColumns: _flatColumns
      };

      _this2._initSort();

      return _this2;
    }

    _createClass(SortTable, [{
      key: "componentWillReceiveProps",
      value: //默认是前端排序，值为true为后端排序
      function componentWillReceiveProps(nextProps) {
        if (nextProps.columns !== this.props.columns) {
          var flatColumns = this._toFlatColumn(nextProps.columns, -1);

          this.setState({
            columns: nextProps.columns,
            flatColumns: flatColumns
          });
        }

        if (nextProps.data !== this.props.data) {
          this.setState({
            data: nextProps.data,
            oldData: nextProps.data.concat()
          }, function () {
            this._initSort(); // 数据更新后需要重新排序

          });
        }
      } //初始化或data数据变化时重新依据排序状态进行排序

    }, {
      key: "_toFlatColumn",
      value:
      /**
       *column扁平化处理，适应多表头避免递归操作
       *
       */
      function _toFlatColumn(columns) {
        var parentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var flatColumns = arguments.length > 2 ? arguments[2] : undefined;

        var _this = this;

        var children = [];
        flatColumns = flatColumns || []; // const flatColumns = _this.state;

        columns.forEach(function (item, index) {
          item.parentIndex = parentIndex;
          children = item.children;
          flatColumns.push(item);

          if (children) {
            // item.children = [];
            _this._toFlatColumn(children, flatColumns.length - 1, flatColumns);
          }
        });
        return flatColumns;
      }
    }, {
      key: "_flatToColumn",
      value: function _flatToColumn(flatColumns) {
        var colLen = flatColumns.length;
        var parentIndex,
            rsColumns = []; //每次渲染需要将父类的children置空，避免重复

        flatColumns.forEach(function (item) {
          if (item.children) {
            item.children = [];
          }
        });

        for (var i = colLen - 1; i >= 0; i--) {
          parentIndex = flatColumns[i].parentIndex;

          if (parentIndex >= 0) {
            flatColumns[parentIndex].children.unshift(flatColumns[i]);
          }
        }

        rsColumns = flatColumns.filter(function (item) {
          return item.parentIndex == -1;
        });
        return rsColumns;
      } //列宽度拖拽后需要更新sort组件的state.columns数据（否则点了排序后被拖拽的列宽度会被还原）

    }, {
      key: "render",
      value: function render() {
        var columns = this.renderColumnsDropdown(this.state.flatColumns.concat());
        return /*#__PURE__*/React.createElement(Table, _extends({}, this.props, {
          columns: columns,
          data: this.state.data,
          onDropBorder: this.handleDropBorder
        }));
      }
    }]);

    return SortTable;
  }(Component), _defineProperty(_class, "defaultProps", {
    prefixCls: 'u-table',
    sort: {
      mode: "single",
      backSource: false
    }
  }), _temp;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/lib/sort.js